import { render } from "./cover-types.vue?vue&type=template&id=b1369778&lang=html"
import script from "./cover-types.vue?vue&type=script&lang=js"
export * from "./cover-types.vue?vue&type=script&lang=js"

import "./cover-types.vue?vue&type=style&index=0&id=b1369778&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__